import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';

class ClientAdd extends React.Component {

    constructor(props) {
        super(props);
        console.log(props.editData);
        this.state = {
            show: props.isOpenAddModal,
            formData: {
                emails: ''
            }
        }
    }

    onClose = () => this.setState({ show: false }, () => this.props.hideAddModal());

    render() {
        let { clientType, onChange, formData, newGroupName, isMobile, onSave } = this.props;
        console.log(isMobile)
        const { show } = this.state;
        let _id = formData._id;
        let emailInput;
        let text;
        if (clientType === 'clients') {
            text = _id ? 'Edit Client' : 'Add New Client';
            emailInput = (
                <TextField
                    label="Email"
                    name="emails"
                    value={formData.emails}
                    margin="dense"
                    variant="outlined"
                    placeholder="jon@doe.com"
                    helperText=""
                    onChange={onChange}
                />)
        } else {
            text = _id ? 'Edit Group' : 'Add New Group';
            emailInput = (
                <TextField
                    rows={3}
                    label="Emails"
                    name="emails"
                    value={formData.emails}
                    margin="dense"
                    variant="outlined"
                    placeholder="jon@doe.com,jane@doe.com"
                    helperText="Enter Client email addresses separated by commas"
                    onChange={onChange}
                />)
        }

        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: isMobile ? '100%' : 650, height: 300 }}>
                    {clientType === 'clients' &&
                        <Fragment>
                            <ModalHeading
                                text={text}
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="First Name"
                                            value={formData.firstName}
                                            name="firstName"
                                            margin="dense"
                                            variant="outlined"
                                            onChange={event => onChange(event, 'firstName')}
                                            inputProps={{maxLength: 60}}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Last Name"
                                            value={formData.lastName}
                                            name="lastName"
                                            margin="dense"
                                            variant="outlined"
                                            onChange={event => onChange(event, 'lastName')}
                                            inputProps={{maxLength: 60}}
                                        />
                                    </Grid>
                                </Grid>
                                {emailInput}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSave}
                                >
                                    <ButtonContent
                                        text="Save"
                                        icon="chevron-right" />
                                </Button>
                            </div>
                        </Fragment>
                    }
                    {clientType === 'groups' &&
                        <Fragment>
                            <ModalHeading
                                text={text}
                                closeModal={this.onClose} />
                            <div className="modalContent">
                                <TextField
                                    label="Group Name"
                                    value={newGroupName}
                                    name="groupName"
                                    margin="dense"
                                    variant="outlined"
                                    onChange={onChange}
                                    inputProps={{maxLength: 60}}
                                />
                                {emailInput}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSave}
                                >
                                    <ButtonContent
                                        text="Save"
                                        icon="chevron-right" />
                                </Button>
                            </div>
                        </Fragment>
                    }
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(ClientAdd));



// WEBPACK FOOTER //
// ./src/components/assignments/ClientAdd.js